const AccountSocialTransferRouter = [
  {
    path     : '/account/social-transfer',
    component: () => import ('@/app/layout/view/layout-default.vue'),
    redirect : '/account/social-transfer/account-social-transfer-confirm-id',
    children : [
      {
        path     : 'account-social-transfer-confirm-id',
        meta     : {routerGuard: true},
        component: () => import('@/app/account/social-transfer/view/account-social-transfer-confirm-id.vue'),
      },
      {
        path     : 'account-social-transfer-result-id',
        meta     : {routerGuard: true},
        component: () => import('@/app/account/social-transfer/view/account-social-transfer-result-id.vue'),
      },
      {
        path     : 'account-social-transfer-form',
        meta     : {routerGuard: true},
        component: () => import('@/app/account/social-transfer/view/account-social-transfer-form.vue'),
      },
      {
        path     : 'account-social-transfer-complete',
        meta     : {routerGuard: true},
        component: () => import('@/app/account/social-transfer/view/account-social-transfer-complete.vue'),
      },
      {
        path     : 'account-social-transfer-confirm-auth',
        meta     : {routerGuard: true},
        component: () => import('@/app/account/social-transfer/view/account-social-transfer-confirm-auth.vue'),
      }
    ]
  }
];

export default AccountSocialTransferRouter;
